export const translationSolutions_da = {
  confirmDeleteFreshdeskIntegration:
    'Fjern Freshdesk-integration "{name}"? Dette kan ikke fortrydes.',
  confirmDeleteHttpIntegration: 'Fjern HTTP-integration "{name}"? Dette kan ikke fortrydes.',
  confirmDeleteShopifyCredentials:
    "Slet Shopify-legitimationsoplysninger? Dette kan ikke fortrydes.",
  confirmDeleteMagentoCredentials:
    "Slet Magento-legitimationsoplysninger? Dette kan ikke fortrydes.",
  confirmDeleteShipmondoCredentials:
    "Slet Shipmondo-legitimationsoplysninger? Dette kan ikke fortrydes.",
  confirmDeleteCommerceToolsCredentials:
    "Slet CommerceTools-legitimationsoplysninger? Dette kan ikke fortrydes.",
  confirmDeleteRaptorCredentials: "Slet Raptor-legitimationsoplysninger? Dette kan ikke fortrydes.",
  confirmRemoveKnowledgeBaseIndex:
    'Fjern vidensbase-indeks "{namespace}" ({indexName})? Dette kan ikke fortrydes.',
};
